var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04482 3.32483C4.68928 4.13436 3 6.36708 3 9C3 9.55228 2.55228 10 2 10C1.44772 10 1 9.55228 1 9C1 4.57772 4.57772 1 9 1C9.36027 1 9.69269 1.19379 9.8702 1.5073C10.0477 1.82081 10.0429 2.20556 9.8575 2.51449L8.80751 4.26449C8.52336 4.73807 7.9091 4.89164 7.43552 4.6075C6.99121 4.34091 6.82858 3.78377 7.04482 3.32483Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 15.7V19.81C1 20.6825 1.08462 21.6312 1.73804 22.2798C2.38872 22.9256 3.33902 23.01 4.21997 23.01H9.78003C10.661 23.01 11.6113 22.9256 12.262 22.2798C12.9154 21.6312 13 20.6825 13 19.81V15.7C13 14.8275 12.9154 13.8788 12.262 13.2302C11.6113 12.5844 10.661 12.5 9.78003 12.5H4.21997C3.33902 12.5 2.38872 12.5844 1.73804 13.2302C1.08462 13.8788 1 14.8275 1 15.7ZM3.14693 14.6498C3.13537 14.6612 3 14.8125 3 15.7V16.06H11V15.7C11 14.8125 10.8646 14.6612 10.8531 14.6498C10.8388 14.6356 10.6791 14.5 9.78003 14.5H4.21997C3.32092 14.5 3.16123 14.6356 3.14693 14.6498ZM11 19.81V18.06H3V19.81C3 20.6975 3.13537 20.8488 3.14693 20.8602C3.16123 20.8744 3.32092 21.01 4.21997 21.01H9.78003C10.6791 21.01 10.8388 20.8744 10.8531 20.8602C10.8646 20.8488 11 20.6975 11 19.81Z",
    fill: "#011235"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15C23 14.4477 22.5523 14 22 14C21.4477 14 21 14.4477 21 15C21 17.6329 19.3107 19.8656 16.9552 20.6752C17.1714 20.2162 17.0088 19.6591 16.5645 19.3925C16.0909 19.1084 15.4766 19.2619 15.1925 19.7355L14.1425 21.4855C13.9571 21.7944 13.9523 22.1792 14.1298 22.4927C14.3073 22.8062 14.6397 23 15 23C19.4223 23 23 19.4223 23 15Z",
    fill: "#011235"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 1C14.4624 1 12 3.46243 12 6.5C12 9.53757 14.4624 12 17.5 12C20.5376 12 23 9.53757 23 6.5C23 3.46243 20.5376 1 17.5 1ZM14 6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5C21 8.433 19.433 10 17.5 10C15.567 10 14 8.433 14 6.5Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.642d9d17d15219bb7b86e213be6ec794.svg";
export { ForwardRef as ReactComponent };